if (!customElements.get('our-story-tabs')) {
  customElements.define(
    'our-story-tabs',
    class OurStoryTabs extends HTMLElement {
      constructor() {
        super();
        this.onTabClick = this.onTabClick.bind(this);
        this.onTabKeydown = this.onTabKeydown.bind(this);
        this.onDropdownToggle = this.onDropdownToggle.bind(this);
        this.onDropdownLinkClick = this.onDropdownLinkClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        this.wrapper = this.closest('.our-story_main-wrapper');
        const scope = this.wrapper || this;

        this.tabLinks = this.querySelectorAll('.our-story_tabmenu .our-story_tablinks');
        this.panes = this.querySelectorAll('.our-story_tabcontent > .our-story_tabpane');
        this.dropdown = this.querySelector('.our-story_dropdown');
        this.dropdownToggle = this.querySelector('.our-story_dropdown-toggle');
        this.dropdownLinks = this.querySelectorAll('.our-story_dropdown-link');
        this.replaceText = this.querySelector('.our-story_replace-text');

        if (!this.dropdown && scope !== this) {
          this.dropdown = scope.querySelector('.our-story_dropdown');
          this.dropdownToggle = scope.querySelector('.our-story_dropdown-toggle');
          this.dropdownLinks = scope.querySelectorAll('.our-story_dropdown-link');
          this.replaceText = scope.querySelector('.our-story_replace-text');
        }

        this.tabLinks.forEach((link, index) => {
          link.dataset.storyIndex = String(index);
          link.addEventListener('click', this.onTabClick);
          link.addEventListener('keydown', this.onTabKeydown);
        });

        this.dropdownLinks.forEach((link) => {
          link.addEventListener('click', this.onDropdownLinkClick);
        });

        this.dropdownToggle?.addEventListener('click', this.onDropdownToggle);
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);

        this.selectTab(this.getInitialTabIndex());
      }

      disconnectedCallback() {
        this.tabLinks?.forEach((link) => {
          link.removeEventListener('click', this.onTabClick);
          link.removeEventListener('keydown', this.onTabKeydown);
        });
        this.dropdownLinks?.forEach((link) => {
          link.removeEventListener('click', this.onDropdownLinkClick);
        });
        this.dropdownToggle?.removeEventListener('click', this.onDropdownToggle);
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      getInitialTabIndex() {
        const current = this.querySelector('.our-story_tablinks.w--current');
        if (current?.dataset.storyIndex != null) {
          return Number(current.dataset.storyIndex);
        }
        const activePane = this.querySelector('.our-story_tabpane.w--tab-active');
        if (activePane?.dataset.storyIndex != null) {
          return Number(activePane.dataset.storyIndex);
        }
        return 0;
      }

      onTabClick(event) {
        event.preventDefault();
        const link = event.currentTarget;
        if (link.classList.contains('w--current')) return;
        this.selectTab(Number(link.dataset.storyIndex), link);
      }

      onTabKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.onTabClick(event);
      }

      onDropdownLinkClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const index = Number(event.currentTarget.dataset.storyIndex);
        this.selectTab(index);
        this.closeDropdown();
      }

      onDropdownToggle(event) {
        event.preventDefault();
        event.stopPropagation();
        this.toggleDropdown();
      }

      onDocumentClick(event) {
        if (!this.dropdown?.contains(event.target)) {
          this.closeDropdown();
        }
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          this.closeDropdown();
        }
      }

      toggleDropdown() {
        if (this.dropdown?.classList.contains('is-open')) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      }

      openDropdown() {
        this.dropdown?.classList.add('is-open');
        this.dropdownToggle?.setAttribute('aria-expanded', 'true');
      }

      closeDropdown() {
        this.dropdown?.classList.remove('is-open');
        this.dropdownToggle?.setAttribute('aria-expanded', 'false');
      }

      selectTab(index, activeLink) {
        if (Number.isNaN(index) || index < 0 || index >= this.panes.length) return;

        this.tabLinks.forEach((link, linkIndex) => {
          const isActive = linkIndex === index;
          link.classList.toggle('w--current', isActive);
          link.setAttribute('aria-selected', isActive ? 'true' : 'false');
          link.tabIndex = isActive ? 0 : -1;
        });

        this.panes.forEach((pane, paneIndex) => {
          const isActive = paneIndex === index;
          pane.classList.toggle('w--tab-active', isActive);
          if (isActive) {
            pane.removeAttribute('hidden');
          } else {
            pane.setAttribute('hidden', '');
          }
        });

        const activeDropdownLink = this.dropdownLinks[index];
        const labelNode = this.tabLinks[index]?.querySelector('.our-story_topic-text');

        if (this.replaceText) {
          if (activeDropdownLink) {
            this.replaceText.textContent = activeDropdownLink.textContent.trim();
          } else if (labelNode) {
            this.replaceText.textContent = labelNode.textContent.trim();
          }
        }

        this.dropdownLinks.forEach((link, linkIndex) => {
          const isActive = linkIndex === index;
          link.classList.toggle('is-active', isActive);
          link.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        if (activeLink) {
          activeLink.focus({ preventScroll: true });
        }
      }
    }
  );
}
